import type { BookingCustomerInformationRequirements } from 'owa-graph-schema';
import type RequirementEnum from 'owa-service/lib/contract/RequirementEnum';
import type BookingRequirementLevel from '../../constants/bookingRequirementLevel';
import type CustomerInformationRequirementTypesB2 from '../../../schema/CustomerInformationRequirementTypesB2';

const mapRequirementEnum = (requirement: RequirementEnum) => {
    switch (requirement) {
        case 0:
            return 'Hidden';
        case 1:
            return 'Optional';
        case 2:
            return 'Required';
    }
};

const mapCustomerInformationRequirements = (
    bookingsCustomerInformationRequirements: CustomerInformationRequirementTypesB2
): BookingCustomerInformationRequirements | undefined => {
    if (!bookingsCustomerInformationRequirements) {
        return;
    }
    const {
        Address = '',
        Email = '',
        Name = '',
        Notes = '',
        Phone = '',
        GuestEmails = '',
    } = bookingsCustomerInformationRequirements;

    return {
        name: mapRequirementEnum(Name as RequirementEnum),
        address: mapRequirementEnum(Address as RequirementEnum),
        email: mapRequirementEnum(Email as RequirementEnum),
        phone: mapRequirementEnum(Phone as RequirementEnum),
        notes: mapRequirementEnum(Notes as RequirementEnum),
        guestEmails: mapRequirementEnum(GuestEmails as RequirementEnum),
    };
};

export default mapCustomerInformationRequirements;
